import { ChangeDetectorRef, Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { Subject, takeUntil } from 'rxjs';
import { CommonService } from 'src/app/service/common.service';
import { TranslationService } from 'src/app/service/translation.service';

@Component({
  selector: 'app-view-toggle',
  standalone: true,
  imports: [],
  templateUrl: './view-toggle.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./view-toggle.component.css']
})
export class ViewToggleComponent implements OnInit, OnDestroy {
  viewMode: 'table' | 'card' = 'table';
  isMobile = false;

  private destroy$ = new Subject<void>();

  constructor(
    public commonService: CommonService,
    public translationService: TranslationService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.commonService.viewMode$
      .pipe(takeUntil(this.destroy$))
      .subscribe(mode => (this.viewMode = mode));

    this.commonService.isMobile$
      .pipe(takeUntil(this.destroy$))
      .subscribe(isMobile => (this.isMobile = isMobile));

    this.translationService.currentLang$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.cdr.markForCheck());
  }

  setMode(mode: 'table' | 'card'): void {
    this.commonService.setViewMode(mode);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
